export default "__VITE_ASSET__hFQ4VQIT__"